import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[appOnlyNumbers]'
})
export class OnlyNumbersDirective {

    @HostListener('beforeinput', ['$event'])
    onBeforeInput(event: InputEvent): void {
        if (!event.data) return;

        const pattern = /^[0-9.\s]*$/;

        if (!pattern.test(event.data)) {
            event.preventDefault();
        }
    }

    @HostListener('paste', ['$event'])
    onPaste(event: ClipboardEvent): void {
        const pastedText = event.clipboardData?.getData('text') || '';
        const pattern = /^[0-9.\s]*$/;

        if (!pattern.test(pastedText)) {
            event.preventDefault();
        }
    }
}